import EFPicture from 'elem/compCommon/EFPicture';
import { useGlobal } from '@/utils/useGlobal';

export default function B() {
    const { useEffect, useState, useLang, gtm, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('solar_panel_160w_single');
    return (
        <div className="sp-160-single-B">
            <div className="pc features">
                <div className="l">
                    <div className="box l-t">
                        <EFPicture src={'/responsive/picture/solar-panel-160w-single/2_1.jpg'} alt={t('B_1_text')} />
                        <div className="box-text">{t('B_1_text')}</div>
                    </div>
                    <div className="box l-b">
                        <EFPicture src={'/responsive/picture/solar-panel-160w-single/2_2.jpg'} alt={t('B_2_text')} />
                        <div className="box-text">
                            {t.rich('B_2_text', {
                                s: (text: string) => <p className="small-text">{text}</p>,
                            })}
                        </div>
                    </div>
                </div>
                <div className="m box">
                    <EFPicture src={'/responsive/picture/solar-panel-160w-single/2_3.jpg'} alt={t('B_3_text')} />
                    <div className="box-text">
                        {t.rich('B_3_text', {
                            s: (text: string) => <p className="small-text">{text}</p>,
                        })}
                    </div>
                </div>
                <div className="r">
                    <div className="box r-t">
                        <EFPicture src={'/responsive/picture/solar-panel-160w-single/2_4.jpg'} alt={t('B_4_text')} />
                        <div className="box-text">
                            {t.rich('B_4_text', {
                                s: (text: string) => <p className="small-text">{text}</p>,
                            })}
                        </div>
                    </div>
                    <div className="box r-b">
                        <EFPicture src={'/responsive/picture/solar-panel-160w-single/2_5.jpg'} alt={t('B_5_text')} />
                        <div className="box-text">
                            {t.rich('B_5_text', {
                                s: (text: string) => <p className="small-text">{text}</p>,
                            })}
                        </div>
                    </div>
                </div>
            </div>
            <div className="h5 features">
                <div className="t box">
                    <EFPicture src={'/responsive/picture/solar-panel-160w-single/2_3_768.jpg'} alt={t('B_3_text')} />
                    <div className="box-text">
                        {t.rich('B_3_text', {
                            s: (text: string) => <p className="small-text">{text}</p>,
                        })}
                    </div>
                </div>
                <div className="b">
                    <div className="b-l">
                        <div className="b-l-t box">
                            <EFPicture src={'/responsive/picture/solar-panel-160w-single/2_1_768.jpg'} alt={t('B_1_text')} />
                            <div className="box-text">{t('B_1_text')}</div>
                        </div>
                        <div className="b-l-b box">
                            <EFPicture src={'/responsive/picture/solar-panel-160w-single/2_5_768.jpg'} alt={t('B_5_text')} />
                            <div className="box-text">
                                {t.rich('B_5_text', {
                                    s: (text: string) => <p className="small-text">{text}</p>,
                                })}
                            </div>
                        </div>
                    </div>
                    <div className="b-r">
                        <div className="b-r-t box">
                            <EFPicture src={'/responsive/picture/solar-panel-160w-single/2_4_768.jpg'} alt={t('B_4_text')} />
                            <div className="box-text">
                                {t.rich('B_4_text', {
                                    s: (text: string) => <p className="small-text">{text}</p>,
                                })}
                            </div>
                        </div>
                        <div className="b-r-b box">
                            <EFPicture src={'/responsive/picture/solar-panel-160w-single/2_2_768.jpg'} alt={t('B_2_text')} />
                            <div className="box-text">
                                {t.rich('B_2_text', {
                                    s: (text: string) => <p className="small-text">{text}</p>,
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
